
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "jst/ExternalTools/_external_tools_menu";
import "i18n!wiki.wiki_page_index_item";
import "coffeescripts/handlebars_helpers.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = 'wiki/WikiPageIndexItem';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); partials = this.merge(partials, Handlebars.partials); data = data || {};
  var buffer = "", stack1, helper, options, self=this, functionType="function", escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing;

function program1(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n  <td role=\"gridcell\" class='not_clickable'>\n    ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.cannot_delete_by_master_course), {hash:{},inverse:self.noop,fn:self.program(2, program2, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </td>\n";
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n      ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.CAN)),stack1 == null || stack1 === false ? stack1 : stack1.DELETE), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  return buffer;
  }
function program3(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n        <input\n          type=\"checkbox\"\n          class=\"select-page-checkbox\"\n          id=";
  if (helper = helpers.page_id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.page_id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n          aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'title': ((depth0 && depth0.title)),
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "select_title_for_deletion_45b08247", "Select %{title} for deletion", options) : helperMissing.call(depth0, "t", "select_title_for_deletion_45b08247", "Select %{title} for deletion", options)))
    + "\"\n          ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.deletable), {hash:{},inverse:self.noop,fn:self.program(4, program4, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isChecked), {hash:{},inverse:self.noop,fn:self.program(6, program6, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        />\n      ";
  return buffer;
  }
function program4(depth0,data) {
  
  
  return "disabled";
  }

function program6(depth0,data) {
  
  var stack1;
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.deletable), {hash:{},inverse:self.noop,fn:self.program(7, program7, data),data:data});
  if(stack1 || stack1 === 0) { return stack1; }
  else { return ''; }
  }
function program7(depth0,data) {
  
  
  return "checked";
  }

function program9(depth0,data) {
  
  var buffer = "", stack1;
  buffer += " ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.published), {hash:{},inverse:self.noop,fn:self.program(10, program10, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "published";
  return buffer;
  }
function program10(depth0,data) {
  
  
  return "un";
  }

function program12(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <span class=\"front-page label\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("wiki.wiki_page_index_item")
  },data:data},helper ? helper.call(depth0, "labels.front_page", "Front Page", options) : helperMissing.call(depth0, "t", "labels.front_page", "Front Page", options)))
    + "</span>\n  ";
  return buffer;
  }

function program14(depth0,data) {
  
  var buffer = "", stack1;
  buffer += " by "
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.last_edited_by)),stack1 == null || stack1 === false ? stack1 : stack1.display_name)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1));
  return buffer;
  }

function program16(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n  <td role=\"gridcell\">"
    + escapeExpression((helper = helpers.tDateToString || (depth0 && depth0.tDateToString),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.todo_date), "date_at_time", options) : helperMissing.call(depth0, "tDateToString", (depth0 && depth0.todo_date), "date_at_time", options)))
    + "</td>\n";
  return buffer;
  }

function program18(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n  <td role=\"gridcell\" class=\"master-content-lock-cell\"></td>\n  ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.CAN)),stack1 == null || stack1 === false ? stack1 : stack1.PUBLISH), {hash:{},inverse:self.noop,fn:self.program(19, program19, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  <td role=\"gridcell\">\n    <div class=\"inline-block\">\n      <a id=\"";
  if (helper = helpers.page_id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.page_id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'title': ((depth0 && depth0.title)),
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "settings_for_title_d3ca495", "Settings for %{title}", options) : helperMissing.call(depth0, "t", "settings_for_title_d3ca495", "Settings for %{title}", options)))
    + "\" class=\"al-trigger al-trigger-gray\" href=\"#\" role=\"button\" data-popup-within=\"#application\">\n        <i class=\"icon-more\" aria-hidden=\"true\"></i>\n        <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("wiki.wiki_page_index_item")
  },data:data},helper ? helper.call(depth0, "menu.settings", "Settings", options) : helperMissing.call(depth0, "t", "menu.settings", "Settings", options)))
    + "</span>\n      </a>\n      <ul class=\"al-options\">\n        ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.cannot_edit_by_master_course), {hash:{},inverse:self.noop,fn:self.program(21, program21, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.cannot_delete_by_master_course), {hash:{},inverse:self.noop,fn:self.program(24, program24, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.front_page), {hash:{},inverse:self.noop,fn:self.program(30, program30, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.front_page), {hash:{},inverse:self.noop,fn:self.program(33, program33, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.CAN)),stack1 == null || stack1 === false ? stack1 : stack1.DUPLICATE), {hash:{},inverse:self.noop,fn:self.program(36, program36, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.DIRECT_SHARE_ENABLED), {hash:{},inverse:self.noop,fn:self.program(38, program38, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  stack1 = self.invokePartial(partials['ExternalTools/external_tools_menu'], 'ExternalTools/external_tools_menu', (depth0 && depth0.wiki_page_menu_tools), helpers, partials, data);
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      </ul>\n    </div>\n  </td>\n";
  return buffer;
  }
function program19(depth0,data) {
  
  
  return "\n    <td role=\"gridcell\" class=\"publish-cell\"></td>\n  ";
  }

function program21(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n          ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.CAN)),stack1 == null || stack1 === false ? stack1 : stack1.UPDATE), {hash:{},inverse:self.noop,fn:self.program(22, program22, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  return buffer;
  }
function program22(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n            <li><a href=\"#\" class=\"icon-edit edit-menu-item\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "edit_c5fbea07", "Edit", options) : helperMissing.call(depth0, "t", "edit_c5fbea07", "Edit", options)))
    + "\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "edit_c5fbea07", "Edit", options) : helperMissing.call(depth0, "t", "edit_c5fbea07", "Edit", options)))
    + "</a></li>\n          ";
  return buffer;
  }

function program24(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n          ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.CAN)),stack1 == null || stack1 === false ? stack1 : stack1.DELETE), {hash:{},inverse:self.noop,fn:self.program(25, program25, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  return buffer;
  }
function program25(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n            <li>\n              <a href=\"#\" class=\"icon-trash delete-menu-item";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.deletable), {hash:{},inverse:self.noop,fn:self.program(26, program26, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\"\n                 title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'title': ((depth0 && depth0.title)),
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "delete_title_6c18eba5", "Delete %{title}", options) : helperMissing.call(depth0, "t", "delete_title_6c18eba5", "Delete %{title}", options)))
    + "\" ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.deletable), {hash:{},inverse:self.noop,fn:self.program(28, program28, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += ">\n                 "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "delete_a6efa79d", "Delete", options) : helperMissing.call(depth0, "t", "delete_a6efa79d", "Delete", options)))
    + "\n              </a>\n            </li>\n          ";
  return buffer;
  }
function program26(depth0,data) {
  
  
  return " disabled";
  }

function program28(depth0,data) {
  
  
  return "aria-disabled=\"true\"";
  }

function program30(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n          ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.CAN)),stack1 == null || stack1 === false ? stack1 : stack1.UPDATE), {hash:{},inverse:self.noop,fn:self.program(31, program31, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  return buffer;
  }
function program31(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n            <li>\n              <a href=\"#\" class=\"unset-as-front-page-menu-item";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.published), {hash:{},inverse:self.noop,fn:self.program(26, program26, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\"\n                 title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "remove_as_front_page_2698aa12", "Remove as Front Page", options) : helperMissing.call(depth0, "t", "remove_as_front_page_2698aa12", "Remove as Front Page", options)))
    + "\" ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.published), {hash:{},inverse:self.noop,fn:self.program(28, program28, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += ">\n                  <i class=\"icon-remove-bookmark\" aria-hidden=\"true\">\n                   "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "remove_as_front_page_2698aa12", "Remove as Front Page", options) : helperMissing.call(depth0, "t", "remove_as_front_page_2698aa12", "Remove as Front Page", options)))
    + "\n                  </i>\n              </a>\n            </li>\n          ";
  return buffer;
  }

function program33(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n          ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.CAN)),stack1 == null || stack1 === false ? stack1 : stack1.UPDATE), {hash:{},inverse:self.noop,fn:self.program(34, program34, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  return buffer;
  }
function program34(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n            <li>\n              <a href=\"#\" class=\"use-as-front-page-menu-item";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.published), {hash:{},inverse:self.noop,fn:self.program(26, program26, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\"\n                 title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "use_as_front_page_274a488b", "Use as Front Page", options) : helperMissing.call(depth0, "t", "use_as_front_page_274a488b", "Use as Front Page", options)))
    + "\" ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.published), {hash:{},inverse:self.noop,fn:self.program(28, program28, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += ">\n                  <i class=\"icon-bookmark\" aria-hidden=\"true\">\n                    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "use_as_front_page_274a488b", "Use as Front Page", options) : helperMissing.call(depth0, "t", "use_as_front_page_274a488b", "Use as Front Page", options)))
    + "\n                  </i>\n              </a>\n            </li>\n          ";
  return buffer;
  }

function program36(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n          <li>\n            <a href=\"#\" class=\"icon-copy-course duplicate-wiki-page\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "duplicate_31cec192", "Duplicate", options) : helperMissing.call(depth0, "t", "duplicate_31cec192", "Duplicate", options)))
    + "\">\n              "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "duplicate_31cec192", "Duplicate", options) : helperMissing.call(depth0, "t", "duplicate_31cec192", "Duplicate", options)))
    + "\n            </a>\n          </li>\n        ";
  return buffer;
  }

function program38(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n          <li>\n            <a\n              href=\"#\"\n              class=\"send-wiki-page-to icon-user\"\n              aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "send_page_to_another_user_6ef5a7c1", "Send page to another user", options) : helperMissing.call(depth0, "t", "send_page_to_another_user_6ef5a7c1", "Send page to another user", options)))
    + "\"\n            >"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "send_to_7881bf0e", "Send to...", options) : helperMissing.call(depth0, "t", "send_to_7881bf0e", "Send to...", options)))
    + "</a>\n          </li>\n          <li>\n            <a\n              href=\"#\"\n              class=\"copy-wiki-page-to icon-duplicate\"\n              aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "copy_page_to_another_course_405cc07c", "Copy page to another course", options) : helperMissing.call(depth0, "t", "copy_page_to_another_course_405cc07c", "Copy page to another course", options)))
    + "\"\n            >"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "copy_to_a5396a6f", "Copy to...", options) : helperMissing.call(depth0, "t", "copy_to_a5396a6f", "Copy to...", options)))
    + "</a>\n          </li>\n        ";
  return buffer;
  }

  stack1 = helpers['if'].call(depth0, (depth0 && depth0.BULK_DELETE_ENABLED), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n<td role=\"gridcell\">\n  <a href=\"";
  if (helper = helpers.html_url) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.html_url); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" id=\"wiki_page_index_item_title_";
  if (helper = helpers.page_id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.page_id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" class=\"wiki-page-link";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.CAN)),stack1 == null || stack1 === false ? stack1 : stack1.PUBLISH), {hash:{},inverse:self.noop,fn:self.program(9, program9, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\">";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</a>\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.front_page), {hash:{},inverse:self.noop,fn:self.program(12, program12, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</td>\n<td role=\"gridcell\">"
    + escapeExpression((helper = helpers.tDateToString || (depth0 && depth0.tDateToString),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.created_at), "medium", options) : helperMissing.call(depth0, "tDateToString", (depth0 && depth0.created_at), "medium", options)))
    + "</td>\n<td role=\"gridcell\">"
    + escapeExpression((helper = helpers.tDateToString || (depth0 && depth0.tDateToString),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.updated_at), "medium", options) : helperMissing.call(depth0, "tDateToString", (depth0 && depth0.updated_at), "medium", options)));
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.last_edited_by)),stack1 == null || stack1 === false ? stack1 : stack1.display_name), {hash:{},inverse:self.noop,fn:self.program(14, program14, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "</td>\n";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.collectionHasTodoDate), {hash:{},inverse:self.noop,fn:self.program(16, program16, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.CAN)),stack1 == null || stack1 === false ? stack1 : stack1.MANAGE), {hash:{},inverse:self.noop,fn:self.program(18, program18, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  